import React from "react";

const LightbulbIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 20, height = 20, color = "#F3B900" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 15.5228 15.5228 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0ZM6.59 2.21C8.76 1.26 11.25 1.26 13.42 2.21L12.18 4.95C10.79 4.35 9.22 4.35 7.83 4.94L6.59 2.21ZM17.79 6.59C18.74 8.75 18.74 11.24 17.79 13.41L15.06 12.17C15.65 10.78 15.65 9.21 15.05 7.83L17.79 6.59ZM2.21 6.58C1.26 8.76 1.26 11.24 2.21 13.42L4.95 12.17C4.35 10.79 4.35 9.21 4.95 7.82L2.21 6.58ZM13.42 17.78C11.25 18.74 8.76 18.74 6.59 17.79L7.84 15.06C9.22 15.65 10.8 15.65 12.18 15.05L13.42 17.78ZM6 10C6 7.79086 7.79086 6 10 6C12.2091 6 14 7.79086 14 10C14 12.2091 12.2091 14 10 14C7.79086 14 6 12.2091 6 10Z"
      fill={color}
    />
  </svg>
);

export default LightbulbIcon;
